import { gql } from '@apollo/client'

export const GET_USER_BY_EMAIL = gql`
  query ($email: String!) {
    findUserByEmail(email: $email) {
      abilities {
        canCreateStory
        canCreateCampaign
        canViewAdminTab
        canChangeCampaignUnit
        canGlobalize
      }
      id
      email
      first_name
      last_name
      country_code
      label_id
      unit_id
      space_id
      region_id
      assigned_campaigns {
        id
      }
      role {
        role_id
      }
    }
  }
`
